import { render, staticRenderFns } from "./ScrollUpdate.vue?vue&type=template&id=410befb6&scoped=true&"
import script from "./ScrollUpdate.vue?vue&type=script&lang=js&"
export * from "./ScrollUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ScrollUpdate.vue?vue&type=style&index=0&id=410befb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410befb6",
  null
  
)

export default component.exports